import React from "react";
import styled from "styled-components";
import colours from "../../lib/colours";
import CloseButton from "../atoms/CloseButton";
import { FilledButtonAlt } from "../atoms/FilledButton";
import { ReactComponent as RulerIcon } from "../../assets/svg/ruler.svg";

const StyledMeasureContainerClosed = styled.div`
  position: absolute;
  right: 15px;
  background-color: ${colours.white};
  z-index: 1;
  color: ${colours.white};
  box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 25%);
  display: flex;
  top: 158px;
  @media (max-width: 1400px) {
    top: 212px;
  }
`;

const StyledMeasureContainerOpen = styled.div`
  position: absolute;
  background-color: ${colours.white};
  z-index: 2;
  color: ${colours.white};
  box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 25%);
  margin-top: 89px;
  display: flex;
  flex-direction: column;
`;

const StyledMeasureButton = styled(FilledButtonAlt)`
  border-radius: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledHeadingContainer = styled.div`
  text-align: left;
  padding: 10px 8px 8px 20px;
  max-width: 342px;
  color: ${colours.th1};
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
`;

const StyledHeading = styled.h3`
  font-weight: 400;
  font-size: 16px;
  color: ${colours.th1};
  margin-block: 0;
  margin-inline: 8px;
  text-transform: uppercase;
  flex: 1;
`;

const StyledCloseButtonContainer = styled.div``;

const StyledIconContainer = styled.div`
  position: relative;
  top: 3px;
`;

const iconStyle = {
  height: "18px",
  width: "18px",
  color: colours.th1,
};

interface IProps {
  open: boolean;
  setOpen: any;
  setClosed: any;
}

function MeasureButton({ open, setOpen, setClosed }: IProps) {
  const handleClose = () => {
    setClosed();
  };
  const handleOpen = () => {
    setOpen();
  };

  return (
    <>
      <StyledMeasureContainerClosed
        style={{ display: open ? "none" : "block" }}
      >
        <StyledMeasureButton onClick={handleOpen}>
          <RulerIcon style={iconStyle} />
        </StyledMeasureButton>
      </StyledMeasureContainerClosed>
      <StyledMeasureContainerOpen
        id="measure-widget-div"
        style={{ visibility: open ? "visible" : "hidden" }}
      >
        <StyledHeadingContainer>
          <StyledIconContainer>
            <RulerIcon style={iconStyle} />
          </StyledIconContainer>
          <StyledHeading>Measure line</StyledHeading>
          <StyledCloseButtonContainer>
            <CloseButton fontSize={"18px"} onClick={handleClose} />
          </StyledCloseButtonContainer>
        </StyledHeadingContainer>
      </StyledMeasureContainerOpen>
    </>
  );
}

export default MeasureButton;
